<template>
    <a :href="link">
        <div class="relative rounded-md shadow-sm sm:text-lg ring ring-transparent group hover:ring hover:ring-opacity-50 focus:ring-opacity-50 hover:ring-primary-100 text-gray-900 flex content-center mr-2 mb-2"
            :class="color" href="https://tailwindflex.com/tag/card">
            <div
                class="rounded-l-md text-sm bg-black/15 border-r-2 border-black/10 px-1 py-1 sm:py-2 md:px-2 font-medium">
                {{
                title }}</div>
            <div class="text-sm px-1 py-1 sm:py-2 md:px-2 break-all">{{
                content }}</div>
        </div>
    </a>
</template>

<script>

export default {
    props: {
        title: String,
        content: String,
        link: '#',
        color: String
    },
    setup(props) {

    }
}
</script>